import BaseApiClient from '../BaseApiClient';

export class ApiTermsAndConditions extends BaseApiClient {
  async updateTermsAndConditions(
    dto: {
      terms_and_conditions: string;
    },
    id: string
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      this.client
        .put(`/sb-pro-invoices/${id}/terms-and-conditions`, dto)
        .then((res) => {
          if (res.status === 204) {
            resolve(dto.terms_and_conditions);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { termsAndConditionsQueryKeys } from './query-keys';
export {
  useTermsAndConditionsUpdateMutation,
  type UpdateTermsAndConditionsVariables
} from './use-terms-and-conditions-mutations';

